module.exports = __webpack_public_path__ + "static/media/help-nav.77d74916.svg";